import { useParams } from 'react-router';

export const bankingDetailIdUrlParamName = 'bankingDetailId';
type BankingDetailIdUrlParam = typeof bankingDetailIdUrlParamName;

export const useBankingDetailIdUrlParam = () => {
  const { bankingDetailId } = useParams<BankingDetailIdUrlParam>();
  return bankingDetailId;
};
